function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, Fragment } from "react";
import { cn } from "../../common/helpers.js";
import { Typography } from "../Typography/index.js";
import { Container as Root } from "../Container/index.js";
import { Button } from "../Button/index.js";
/**
 * Duplex Hero Block - [API](https://scl.sharp.com/?path=/docs/components-duplexheroblock) | [DSM](https://sharphealthcare.notion.site/Duplex-image-4c9a4315ce7d455693120c4e572df7d9)
 *
 * @example
 *
 * <DuplexHeroBlock
 *   heading="Get care now"
 *   description="We have many care options..."
 *   image={{ src: 'image.jpg' }}
 *   buttonPrimary={{ label: 'Schedule now' }}
 * />
 */ const DuplexHeroBlock = /*#__PURE__*/ forwardRef((props, ref)=>{
    var _slotProps_preHeading, _slotProps_description;
    const { as, preHeading, heading, description, buttonPrimary, buttonSecondary, image = {}, slots = {}, slotProps = {}, className } = props, rest = _object_without_properties(props, [
        "as",
        "preHeading",
        "heading",
        "description",
        "buttonPrimary",
        "buttonSecondary",
        "image",
        "slots",
        "slotProps",
        "className"
    ]);
    var _slots_contentContainer;
    const ContentContainer = (_slots_contentContainer = slots.contentContainer) !== null && _slots_contentContainer !== void 0 ? _slots_contentContainer : 'div';
    var _slotProps_contentContainer;
    const _ref = (_slotProps_contentContainer = slotProps.contentContainer) !== null && _slotProps_contentContainer !== void 0 ? _slotProps_contentContainer : {}, { className: contentContainerSlotPropsClassName } = _ref, contentContainerSlotProps = _object_without_properties(_ref, [
        "className"
    ]);
    var _slots_preHeading;
    const PreHeading = (_slots_preHeading = slots.preHeading) !== null && _slots_preHeading !== void 0 ? _slots_preHeading : Typography;
    var _slotProps_preHeading1;
    const _ref1 = (_slotProps_preHeading1 = slotProps.preHeading) !== null && _slotProps_preHeading1 !== void 0 ? _slotProps_preHeading1 : {}, { className: preHeadingSlotPropsClassName } = _ref1, preHeadingSlotProps = _object_without_properties(_ref1, [
        "className"
    ]);
    // If preHeading slot provided then do not spread Typography specific props else combine
    const preHeadingProps = slots.preHeading ? preHeadingSlotProps : _object_spread({
        variant: 'small-body-semibold'
    }, preHeadingSlotProps);
    var _slots_heading;
    const Heading = (_slots_heading = slots.heading) !== null && _slots_heading !== void 0 ? _slots_heading : Typography;
    var _slotProps_heading;
    const _ref2 = (_slotProps_heading = slotProps.heading) !== null && _slotProps_heading !== void 0 ? _slotProps_heading : {}, { className: headingSlotPropsClassName } = _ref2, headingSlotProps = _object_without_properties(_ref2, [
        "className"
    ]);
    // If heading slot provided then do not spread Typography specific props else combine
    const headingProps = slots.heading ? headingSlotProps : _object_spread({
        variant: 'h1'
    }, headingSlotProps);
    var _slots_description;
    const Description = (_slots_description = slots.description) !== null && _slots_description !== void 0 ? _slots_description : Typography;
    var _slotProps_description1;
    const _ref3 = (_slotProps_description1 = slotProps.description) !== null && _slotProps_description1 !== void 0 ? _slotProps_description1 : {}, { className: descriptionSlotPropsClassName } = _ref3, descriptionSlotProps = _object_without_properties(_ref3, [
        "className"
    ]);
    // If description slot provided then do not spread Typography specific props else combine
    const descriptionProps = slots.description ? descriptionSlotProps : _object_spread({
        variant: 'body',
        as: 'div'
    }, descriptionSlotProps);
    var _slots_buttonContainer;
    const ButtonContainer = (_slots_buttonContainer = slots.buttonContainer) !== null && _slots_buttonContainer !== void 0 ? _slots_buttonContainer : 'div';
    var _slotProps_buttonContainer;
    const _ref4 = (_slotProps_buttonContainer = slotProps.buttonContainer) !== null && _slotProps_buttonContainer !== void 0 ? _slotProps_buttonContainer : {}, { className: buttonContainerSlotPropsClassName } = _ref4, buttonContainerSlotProps = _object_without_properties(_ref4, [
        "className"
    ]);
    var _slots_buttonPrimary, _ref5;
    const hasButtonPrimary = !!((_ref5 = (_slots_buttonPrimary = slots.buttonPrimary) !== null && _slots_buttonPrimary !== void 0 ? _slots_buttonPrimary : slotProps.buttonPrimary) !== null && _ref5 !== void 0 ? _ref5 : buttonPrimary);
    var _slots_buttonSecondary, _ref6;
    const hasButtonSecondary = !!((_ref6 = (_slots_buttonSecondary = slots.buttonSecondary) !== null && _slots_buttonSecondary !== void 0 ? _slots_buttonSecondary : slotProps.buttonSecondary) !== null && _ref6 !== void 0 ? _ref6 : buttonSecondary);
    const hasOneButton = hasButtonPrimary || hasButtonSecondary;
    const hasTwoButtons = hasButtonPrimary && hasButtonSecondary;
    const hasButton = hasOneButton;
    const buttonWidthProp = hasTwoButtons ? 'md' : 'lg';
    var _slots_buttonPrimary1;
    const ButtonPrimary = (_slots_buttonPrimary1 = slots.buttonPrimary) !== null && _slots_buttonPrimary1 !== void 0 ? _slots_buttonPrimary1 : Button;
    var _slotProps_buttonPrimary;
    const _ref7 = (_slotProps_buttonPrimary = slotProps.buttonPrimary) !== null && _slotProps_buttonPrimary !== void 0 ? _slotProps_buttonPrimary : {}, { className: buttonPrimarySlotPropsClassName } = _ref7, buttonPrimarySlotProps = _object_without_properties(_ref7, [
        "className"
    ]);
    const buttonPrimaryDefaultProps = {
        color: 'primary',
        variant: 'filled',
        width: buttonWidthProp
    };
    // If buttonPrimary slot provided then do not spread Button specific props else combine
    const buttonPrimaryProps = slots.buttonPrimary ? buttonPrimarySlotProps : _object_spread({}, buttonPrimaryDefaultProps, buttonPrimary, buttonPrimarySlotProps);
    var _slots_buttonSecondary1;
    const ButtonSecondary = (_slots_buttonSecondary1 = slots.buttonSecondary) !== null && _slots_buttonSecondary1 !== void 0 ? _slots_buttonSecondary1 : Button;
    var _slotProps_buttonSecondary;
    const _ref8 = (_slotProps_buttonSecondary = slotProps.buttonSecondary) !== null && _slotProps_buttonSecondary !== void 0 ? _slotProps_buttonSecondary : {}, { className: buttonSecondarySlotPropsClassName } = _ref8, buttonSecondarySlotProps = _object_without_properties(_ref8, [
        "className"
    ]);
    const buttonSecondaryDefaultProps = {
        color: 'primary',
        variant: 'outlined',
        width: buttonWidthProp
    };
    // If buttonSecondary slot provided then do not spread Button specific props else combine
    const buttonSecondaryProps = slots.buttonSecondary ? buttonSecondarySlotProps : _object_spread({}, buttonSecondaryDefaultProps, buttonSecondary, buttonSecondarySlotProps);
    var _slots_buttonPrimaryContainer;
    const ButtonPrimaryContainer = (_slots_buttonPrimaryContainer = slots.buttonPrimaryContainer) !== null && _slots_buttonPrimaryContainer !== void 0 ? _slots_buttonPrimaryContainer : slotProps.buttonPrimaryContainer ? 'div' : Fragment;
    var _slots_buttonSecondaryContainer;
    const ButtonSecondaryContainer = (_slots_buttonSecondaryContainer = slots.buttonSecondaryContainer) !== null && _slots_buttonSecondaryContainer !== void 0 ? _slots_buttonSecondaryContainer : slotProps.buttonSecondaryContainer ? 'div' : Fragment;
    var _slots_imageContainer;
    const ImageContainer = (_slots_imageContainer = slots.imageContainer) !== null && _slots_imageContainer !== void 0 ? _slots_imageContainer : 'div';
    var _slotProps_imageContainer;
    const _ref9 = (_slotProps_imageContainer = slotProps.imageContainer) !== null && _slotProps_imageContainer !== void 0 ? _slotProps_imageContainer : {}, { className: imageContainerSlotPropsClassName } = _ref9, imageContainerSlotProps = _object_without_properties(_ref9, [
        "className"
    ]);
    var _slots_image;
    const Image = (_slots_image = slots.image) !== null && _slots_image !== void 0 ? _slots_image : 'img';
    const { className: imagePropClassName } = image, imagePropProps = _object_without_properties(image, [
        "className"
    ]);
    var _slotProps_image;
    const _ref10 = (_slotProps_image = slotProps.image) !== null && _slotProps_image !== void 0 ? _slotProps_image : {}, { className: imageSlotPropsClassName } = _ref10, imageSlotProps = _object_without_properties(_ref10, [
        "className"
    ]);
    const imageProps = slots.image ? _object_spread({}, imageSlotProps) : _object_spread({}, imagePropProps, imageSlotProps);
    return /*#__PURE__*/ _jsxs(Root, _object_spread_props(_object_spread({
        className: cn('flex flex-col-reverse lg:flex-row items-center justify-between gap-5 md:gap-8 xl:gap-15 2xl:gap-20', className)
    }, rest), {
        as: as,
        ref: ref,
        children: [
            /*#__PURE__*/ _jsxs(ContentContainer, _object_spread_props(_object_spread({
                className: cn('flex flex-col self-start lg:self-center gap-3 md:gap-5 lg:basis-6/12 xl:basis-5/12', contentContainerSlotPropsClassName)
            }, contentContainerSlotProps), {
                children: [
                    (preHeading !== null && preHeading !== void 0 ? preHeading : (_slotProps_preHeading = slotProps.preHeading) === null || _slotProps_preHeading === void 0 ? void 0 : _slotProps_preHeading.children) && /*#__PURE__*/ _jsx(PreHeading, _object_spread_props(_object_spread({
                        className: cn('line-clamp-1', preHeadingSlotPropsClassName)
                    }, preHeadingProps), {
                        children: preHeading
                    })),
                    /*#__PURE__*/ _jsx(Heading, _object_spread_props(_object_spread({
                        className: cn('line-clamp-3 md:line-clamp-2', headingSlotPropsClassName)
                    }, headingProps), {
                        children: heading
                    })),
                    (description !== null && description !== void 0 ? description : (_slotProps_description = slotProps.description) === null || _slotProps_description === void 0 ? void 0 : _slotProps_description.children) && /*#__PURE__*/ _jsx(Description, _object_spread_props(_object_spread({
                        className: cn('scl-rich-text', descriptionSlotPropsClassName)
                    }, descriptionProps), {
                        children: description
                    })),
                    hasButton && /*#__PURE__*/ _jsxs(ButtonContainer, _object_spread_props(_object_spread({
                        className: cn('flex flex-col md:flex-row gap-5 w-full pt-2 empty:hidden', buttonContainerSlotPropsClassName)
                    }, buttonContainerSlotProps), {
                        children: [
                            hasButtonPrimary && /*#__PURE__*/ _jsx(ButtonPrimaryContainer, _object_spread_props(_object_spread({}, slotProps.buttonPrimaryContainer), {
                                children: /*#__PURE__*/ _jsx(ButtonPrimary, _object_spread({}, buttonPrimaryProps))
                            })),
                            hasButtonSecondary && /*#__PURE__*/ _jsx(ButtonSecondaryContainer, _object_spread_props(_object_spread({}, slotProps.buttonSecondaryContainer), {
                                children: /*#__PURE__*/ _jsx(ButtonSecondary, _object_spread({}, buttonSecondaryProps))
                            }))
                        ]
                    }))
                ]
            })),
            /*#__PURE__*/ _jsx(ImageContainer, _object_spread_props(_object_spread({
                className: cn('lg:basis-6/12 xl:basis-7/12 ', imageContainerSlotPropsClassName)
            }, imageContainerSlotProps), {
                children: /*#__PURE__*/ _jsx(Image, _object_spread({
                    className: cn('rounded-xl w-full aspect-video', imagePropClassName, imageSlotPropsClassName)
                }, imageProps))
            }))
        ]
    }));
});
export { DuplexHeroBlock };
